module.exports = __webpack_public_path__ + "static/Calibre-LightItalic-f34c1430353885b55d271d473235eb6a.woff2";